module.exports = __webpack_public_path__ + "static/media/php_logo.1b29a538.png";